import {
  containsNumberAndLetter,
  isDate,
  showDateOnly,
} from "../../Common/Utility";
import clsx from "clsx";
import PdfIcon from "@mui/icons-material/PictureAsPdf";
import { blue, red } from "@mui/material/colors";
import { Checkbox } from "@mui/material";
const columnsBuilder = (props) => {
  const { regionData, isAdmin = false } = props;

  const columns = [
    {
      field: "studentId",
      headerName: "ID",
      width: 75,
      editable: false,
    },
    {
      field: "branchId",
      headerName: "Abrechnungstelle ID",
      width: 20,
      editable: false,
    },
    {
      field: "isPayed",
      headerName: "Bezahlt €",
      width: 120,
      editable: isAdmin,
      renderCell: (params) => {
        if (params?.value === undefined) return null;
        return (
          <Checkbox
            checked={params.value}
            disabled={!isAdmin}
            inputProps={{ "aria-label": "controlled" }}
          />
        );
      },
    },
    {
      field: "studentName",
      headerName: "Auftrag",
      width: 300,
      valueFormatter: (params) => {
        if (!params?.value) return "";
        return params.value;
      },
      renderCell: (params) => {
        if (!params?.value) return "";
        return params.value;
      },
    },
    {
      field: "regionId",
      headerName: "Ort (Region)",
      type: "singleSelect",
      editable: false,
      width: 120,
      getOptionValue: (region) => region?.id,
      getOptionLabel: (region) => region?.regionName,
      valueOptions: regionData || [],
      valueFormatter: (params) => {
        if (!params?.value || !regionData?.length) return "";
        const region = regionData.find((region) => region.id === params.value);
        return region?.regionName || "";
      },
      renderCell: (params) => {
        if (!params?.value || !regionData?.length) return "";
        const region = regionData.find((region) => region.id === params.value);
        return region?.regionName || "";
      },
    },
    {
      field: "period",
      headerName: "Zeitraum",
      width: 170,
      renderCell: (params) => {
        if (!params?.value) return "";
        return (
          <div
            style={{
              color: "DodgerBlue",
              fontSize: 12,
              width: "100%",
              textAlign: "center",
            }}
          >
            {params.value}
          </div>
        );
      },
    },
    {
      field: "sumOfAmount",
      headerName: "Betrag (€)",
      type: "number",
      width: 100,
      headerClassName: "color--green--header",
      valueFormatter: (params) => {
        if (!params?.value && params?.value !== 0) return "";
        return params.value.toLocaleString("en");
      },
      renderCell: (params) => {
        if (!params?.value && params?.value !== 0) return "";
        return params.value.toLocaleString("en");
      },
      cellClassName: (params) =>
        clsx("super-app", {
          negative: params.value < 0,
          positive: params.value > 0,
        }),
    },
    {
      field: "pdfDate",
      headerName: "PDF-Datum",
      width: 120,
      valueFormatter: (params) => {
        if (!params?.value) return "";
        return isDate(params.value) ? showDateOnly(params.value) : "";
      },
      renderCell: (params) => {
        if (!params?.value) return "";
        return isDate(params.value) ? showDateOnly(params.value) : "";
      },
      filterOperators: [
        {
          label: "contains",
          value: "contains",
          getApplyFilterFn: (filterItem) => {
            if (!filterItem.value) {
              return null;
            }
            return (params) => {
              // Check both the raw date value and the formatted date
              const rawDateValue = params.value ? String(params.value) : "";
              const formattedDateValue = params.value
                ? showDateOnly(params.value)
                : "";

              return (
                rawDateValue
                  .toLowerCase()
                  .includes(filterItem.value.toLowerCase()) ||
                formattedDateValue
                  .toLowerCase()
                  .includes(filterItem.value.toLowerCase())
              );
            };
          },
        },
      ],
    },
    {
      field: "birthDate",
      headerName: "Geburstdatum",
      width: 150,
      valueFormatter: (params) => {
        if (!params?.value) return "";
        return isDate(params.value) ? showDateOnly(params.value) : "";
      },
      renderCell: (params) => {
        if (!params?.value) return "";
        return isDate(params.value) ? showDateOnly(params.value) : "";
      },
      filterOperators: [
        {
          label: "contains",
          value: "contains",
          getApplyFilterFn: (filterItem) => {
            if (!filterItem.value) {
              return null;
            }
            return (params) => {
              // Check both the raw date value and the formatted date
              const rawDateValue = params.value ? String(params.value) : "";
              const formattedDateValue = params.value
                ? showDateOnly(params.value)
                : "";

              return (
                rawDateValue
                  .toLowerCase()
                  .includes(filterItem.value.toLowerCase()) ||
                formattedDateValue
                  .toLowerCase()
                  .includes(filterItem.value.toLowerCase())
              );
            };
          },
        },
      ],
    },
    {
      field: "butNumber",
      headerName: "But-Number",
      width: 160,
      valueFormatter: (params) => {
        if (!params?.value) return "";
        return params.value;
      },
      renderCell: (params) => {
        if (!params?.value) return "";
        return params.value;
      },
    },
    {
      field: "rechnungsnummer",
      headerName: "Rechnungsnummer",
      width: 150,
      headerClassName: "color--red--header",
      valueFormatter: (params) => {
        if (!params?.value) return "";
        return containsNumberAndLetter(params.value) ? params.value : "";
      },
      renderCell: (params) => {
        if (!params?.value) return "";
        return containsNumberAndLetter(params.value) ? params.value : "";
      },
      cellClassName: (params) =>
        clsx("super-app", {
          notEmpty: params.value !== "",
        }),
    },
    {
      field: "pdfFileName",
      headerName: "PDF-Datei",
      width: 350,
      renderCell: (params) => {
        if (!params?.value) return "";
        return (
          <div>
            <span style={{ color: "#d32f2f" }}>
              <PdfIcon />
            </span>
            &nbsp;&nbsp;
            <a href="##">{params.value}</a>
          </div>
        );
      },
    },

    {
      field: "isPartner",
      headerName: "Partner",
      type: "boolean",
      width: 80,
      renderCell: (params) => {
        if (params?.value === undefined) return null;
        return (
          <Checkbox
            checked={params.value}
            inputProps={{ "aria-label": "controlled" }}
          />
        );
      },
      disabled: true,
    },
    {
      field: "userName",
      headerName: "Partner Name",
      width: 130,
      valueFormatter: (params) => params?.value ?? "",
      renderCell: (params) => params?.value ?? "",
    },
    {
      field: "entryDateFrom",
      headerName: "Entry-From",
      width: 100,
      valueFormatter: (params) => {
        if (!params?.value) return "";
        return isDate(params.value) ? showDateOnly(params.value) : "";
      },
      renderCell: (params) => {
        if (!params?.value) return "";
        return isDate(params.value) ? showDateOnly(params.value) : "";
      },
      filterOperators: [
        {
          label: "contains",
          value: "contains",
          getApplyFilterFn: (filterItem) => {
            if (!filterItem.value) {
              return null;
            }
            return (params) => {
              // Check both the raw date value and the formatted date
              const rawDateValue = params.value ? String(params.value) : "";
              const formattedDateValue = params.value
                ? showDateOnly(params.value)
                : "";

              return (
                rawDateValue
                  .toLowerCase()
                  .includes(filterItem.value.toLowerCase()) ||
                formattedDateValue
                  .toLowerCase()
                  .includes(filterItem.value.toLowerCase())
              );
            };
          },
        },
      ],
    },
    {
      field: "entryDateTo",
      headerName: "Entry-To",
      width: 100,
      valueFormatter: (params) => {
        if (!params?.value) return "";
        return isDate(params.value) ? showDateOnly(params.value) : "";
      },
      renderCell: (params) => {
        if (!params?.value) return "";
        return isDate(params.value) ? showDateOnly(params.value) : "";
      },
      filterOperators: [
        {
          label: "contains",
          value: "contains",
          getApplyFilterFn: (filterItem) => {
            if (!filterItem.value) {
              return null;
            }
            return (params) => {
              // Check both the raw date value and the formatted date
              const rawDateValue = params.value ? String(params.value) : "";
              const formattedDateValue = params.value
                ? showDateOnly(params.value)
                : "";

              return (
                rawDateValue
                  .toLowerCase()
                  .includes(filterItem.value.toLowerCase()) ||
                formattedDateValue
                  .toLowerCase()
                  .includes(filterItem.value.toLowerCase())
              );
            };
          },
        },
      ],
    },
  ];
  return columns;
};
export default columnsBuilder;
